import React from 'react';
import * as yup from 'yup';
import { searchRouteOfAdministration } from '../../Async/MedicationsSummaryAsync';
import { FormikStyledSelectAsync } from '../../Components/FormikFields/FormikStyledSelectAsync';
import { FormikTextField } from '../../Components/FormikFields/FormikTextField';
import { referenceToKey, referenceToString } from '../../Shared/SharedModels';
import styles from './EditFreeTextInstructionsForm.module.css';
export var freeTextInstructionSchema = yup.object();
export var strictTextInstructionSchema = function (routeRequired) {
    return yup.object({
        type: yup.mixed(),
        textInstructions: yup.string(),
        instructions: yup.string().required('Instructions are required'),
        routeOfAdministration: yup
            .object()
            .nullable()
            .test({
            name: 'Route of administration is required',
            message: 'Route of administration is required',
            test: function (value) {
                if (routeRequired)
                    return !!value;
                return true;
            }
        })
    });
};
export var EditFreeTextInstructionsForm = function (props) {
    var readOnly = !props.isAdjustMedication && props.readOnly;
    return (React.createElement("div", null,
        React.createElement(FormikTextField, { readOnly: readOnly, name: props.fieldPath + ".instructions", label: props.label, multiline: true, maxLength: 250, required: props.required, testId: props.fieldPath + ".instructions" }),
        React.createElement("div", { className: styles.routeOfAdministration },
            React.createElement(FormikStyledSelectAsync, { readOnly: readOnly, name: props.fieldPath + ".routeOfAdministration", label: 'Route of administration', required: props.requiredRouteOfAdministration, maxResults: 5, itemToString: referenceToString, itemToMenuKey: referenceToKey, testId: 'selection-input-route-of-administration', fetch: searchRouteOfAdministration, isClearable: true, hideWarningEmptyHelperText: true }))));
};
